import React, { useState, useContext } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';

import SimpleSelect from '../SimpleSelect';
import ComboBox from '../Autocomplete';
import { campaignTypes, isActiveTypes } from '../../utils/enums';

import { SurveyContext } from '../../SurveyContext';

const EditCampaignModal = (props) => {

    const { customers } = useContext(SurveyContext);

    const [name, setName] = useState(props.name);
    const [type, setType] = useState(props.type);
    const [isActive, setIsActive] = useState(props.isActive);
    const [customer, setCustomer] = useState(props.customer);
    const [loading, setLoading] = useState(false);

    const { open, onClose, saveClick, action } = props;

    const handleSave = async () => {
        setLoading(true);
        const payload = {
            name: name,
            type: type,
            client: customer.id,
            is_active: isActive
        };
        await saveClick(payload);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle>
                {action === 'new' ? 'New Campaign' : 'Edit Campaign Page'}
            </DialogTitle>
            <DialogContent>
                <div>
                    <TextField
                        label="Campaign Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={{ width: 300, marginBottom: 15 }}
                    />
                </div>
                <div>
                    <SimpleSelect 
                            title="Is Active"
                            onChange={(e) => setIsActive(e)}
                            defaultValue={isActive}
                            options={
                                [
                                    { label: 'Active', value: true, key: isActiveTypes.ACTIVE }, 
                                    { label: 'InActive', value: false, key: isActiveTypes.INACTIVE }
                                ]
                            }
                        />
                </div>
                <div>
                    <SimpleSelect 
                            title="Type"
                            onChange={(e) => setType(e)}
                            defaultValue={type}
                            options={
                                [
                                    { label: 'Blockwise', value: 'blockwise', key: campaignTypes.BLOCKWISE }, 
                                    { label: 'Pulse', value: 'pulse', key: campaignTypes.PULSE }
                                ]
                            }
                        />
                </div>
               { action === 'new' && 
               <div>
                    <TextField
                            label="Customer"
                            value={_.get(props.customer, 'name')}
                            style={{ width: 300, marginBottom: 15 }}
                        />
                </div>
                }
                { action !== 'new' && 
               <div>
                    <ComboBox
                            title="Customer"
                            initialValue={customer}
                            handleOnChange={(customer) => setCustomer(customer)}
                            options={customers || []}

                        />
                </div>
                }
            </DialogContent>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 20 }}>
                <Button onClick={onClose} color="primary" variant="outlined">
                    Close
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant="outlined"
                    disabled={!name || !type || loading}
                >
                    {action === 'new' ? 'Add Campaign' : 'Save Edits'}
                </Button>
            </div>
        </Dialog>
    );
};

export default EditCampaignModal;
